/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AcceptRecomendedItemsCommand } from '../../models/accept-recomended-items-command';
import { AcceptRecomendedItemsCommandResult } from '../../models/accept-recomended-items-command-result';

export interface ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Params {
      body?: AcceptRecomendedItemsCommand
}

export function apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AcceptRecomendedItemsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AcceptRecomendedItemsCommandResult>;
    })
  );
}

apiNurseryManagerOrderDetailsAcceptRecommendedItemPatch$Plain.PATH = '/api/NurseryManager/OrderDetails/AcceptRecommendedItem';
